import {getCurrentInstance, onBeforeUnmount, onMounted, onUpdated} from 'vue'

/**
 * Boots Bootstrap popovers for every `[data-bs-toggle="popover"]` inside the
 * current component, refreshes them on every re-render and disposes them on
 * unmount. Safe to call when Bootstrap isn't available (SSR / tests).
 */
export function useBootstrapPopovers() {
  const instance = getCurrentInstance()
  let popovers = []

  const dispose = () => {
    popovers.forEach((popover) => popover.dispose())
    popovers = []
  }

  const refresh = () => {
    dispose()
    const PopoverCtor = window?.bootstrap?.Popover
    const root = instance?.proxy?.$el
    if (!PopoverCtor || !root?.querySelectorAll) return
    const elements = root.querySelectorAll('[data-bs-toggle="popover"]')
    popovers = Array.from(elements).map((el) => PopoverCtor.getOrCreateInstance(el))
  }

  onMounted(refresh)
  onUpdated(refresh)
  onBeforeUnmount(dispose)
}
